import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Auth } from '@core/services';
import { UserPermission } from '@core/interfaces/userPermission.interface';

export const permissionGuard: CanActivateFn = (route) => {
  const authService = inject(Auth);
  const router = inject(Router);

  const permission = route.data['permission'];
  const user = authService.user;

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  const esimPermissions = user.userPermission?.esimPermissions || {};

  if (permission && !esimPermissions[permission]) {
    // Find first available permission to redirect
    let redirectUrl = '';
    if (esimPermissions[UserPermission.DASHBOARD]) {
      redirectUrl = '/dashboard';
    } else if (esimPermissions[UserPermission.BUY_DATA_BUNDLES]) {
      redirectUrl = '/buy-data-bundles';
    } else if (esimPermissions[UserPermission.TOPUP]) {
      redirectUrl = '/topup';
    } else if (esimPermissions[UserPermission.GLING_GRING_RECHARGE]) {
      redirectUrl = '/gling-gring-recharge';
    } else if (esimPermissions[UserPermission.SCHEDULED_SUBSCRIPTION]) {
      redirectUrl = '/scheduled-subscriptions';
    } else if (esimPermissions[UserPermission.HISTORY]) {
      redirectUrl = '/history';
    } else if (esimPermissions[UserPermission.RESELLER]) {
      redirectUrl = '/reseller';
    } else if (esimPermissions[UserPermission.THAI_ESIM]) {
      redirectUrl = '/thai-esims';
    } else if (esimPermissions[UserPermission.PACKAGE]) {
      redirectUrl = '/package';
    } else if (esimPermissions[UserPermission.SETTINGS]) {
      redirectUrl = '/settings';
    }

    if (redirectUrl) {
      router.navigate([redirectUrl]);
    } else {
      router.navigate(['/login']);
      localStorage.clear();
    }
    return false;
  }

  return true;
};
